<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_TelexReleaseMaterial')"
    width="300px"
    class="make-invoice-adjust-balance-dialog"
    :close-on-click-modal="false"
    :show-close="true"
    @close="cancel"
  >
    <div>
      <div class="form-row" style="min-height: 200px;">
        VSL/VOY：{{ voyageFlight }} <p />
        MBL：{{ mblNo }} <p />
        HBL：{{ hblNo }} <p />
        C/N(QTY：{{ containerNo }} <p />
        POD：{{ dischargingPortCode }}<p />
        ETA：{{ eta }}<p />
      </div>
    </div>
  </el-dialog>
</template>

<script>

import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'ShowSurrenderedWindow',
  props: {
    visible: { type: Boolean, required: true },
    singleReleaseEntity: { type: Object, required: false }
  },
  data() {
    return {
      innerVisible: false,
      voyageFlight: '',
      mblNo: '',
      hblNo: '',
      containerNo: '',
      dischargingPortCode: '',
      eta: ''
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      if (newVal) {
        this.showSurrenderedInfo()
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
    }
  },
  methods: {
    cancel() {
      this.$emit('update:visible', false)
    },
    showSurrenderedInfo() {
      if (this.singleReleaseEntity === null) {
        return
      }
      const s = this.singleReleaseEntity
      if (s.vessel && s.voyageFlight) {
        this.voyageFlight = s.vessel + '/' + s.voyageFlight
      } else if (s.vessel) {
        this.voyageFlight = s.vessel
      } else if (s.voyageFlight) {
        this.voyageFlight = s.voyageFlight
      }
      this.mblNo = this.singleReleaseEntity.mblNo
      this.hblNo = this.singleReleaseEntity.hblNo
      this.containerNo = this.singleReleaseEntity.containerNo
      if (this.singleReleaseEntity.dischargingPortCode) {
        this.dischargingPortCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', this.singleReleaseEntity.dischargingPortCode, 'englishName')
      }
      this.eta = ColumnUtils.dateLabelFunc(this.singleReleaseEntity.eta)
    }
  }
}
</script>

<style>
</style>
